import styled from '@emotion/styled';
import React from 'react';

import { color, font, mediaQueries } from 'src/shared/styles/variables';

const OuterBar = styled.div({
    height: 10,
    width: '100%',
    backgroundColor: color.linkWaterLight,
    borderRadius: 18,
    bottom: '-3em',
    position: 'absolute',

    [mediaQueries.md]: {
        width: '90vw',
    },
});

interface InnerBarProps {
    width: number;
}

const InnerBar = styled.div<InnerBarProps>(({ width }) => ({
    width: `${width}%`,
    height: 'inherit',
    borderRadius: 'inherit',
    position: 'relative',
    transition: 'all 0.4s ease-in-out',
    backgroundColor: color.nepal,
    [mediaQueries.sm]: {
        position: 'static',
    },
}));

const PercentageText = styled.span(
    {
        position: 'absolute',
        bottom: -25,
        color: color.gullGray,
    },
    font.heavy(font.size.base),
);

const MinimumPercentageText = styled(PercentageText)({
    left: 0,
});

const MaximumPercentageText = styled(PercentageText)({
    right: 0,
});

interface Props {
    percent: number;
}

export const AssessmentProgressBar: React.FC<Props> = ({ percent }) => (
    <OuterBar>
        <InnerBar width={percent} />
        <MinimumPercentageText>0%</MinimumPercentageText>
        <MaximumPercentageText>100%</MaximumPercentageText>
    </OuterBar>
);
